import { useEffect } from 'react'
import styled from 'styled-components'
import Link from 'next/link'

const PokedexLinksStyled = styled.div`
  display: none;
  max-width: 230px;
  position: fixed;
  top: 5rem;
  left: 1rem;
  background: var(--neutral100);
  color: var(--white);
  padding: 8px;
  border-radius: 8px;
  h3 {
    font: var(--p2Bold);
  }
  details[open] {
    h3 {
      color: var(--lightBlue)
    }
  }
  a {
    display: block;
    font: var(--p2Regular);
    margin: 4px 0;
  }
  summary {
    cursor: pointer;
    user-select: none;
    list-style-image: unset;
    list-style: none;
  }
  details {
    margin-block-end: 1rem;
    &:last-of-type {
      margin-block-end: 0px;
    }
  }
  summary::marker, summary::-webkit-details-marker {
    display: none;
    color: transparent;
  }
  u {
    color: var(--lightBlue);
  }
  @media (min-width: 1270px) {
    display: block;
  }
  @media (min-width: 1282px) {
    max-width: 270px;
  }
`

function PokedexLinks() {
  useEffect(() => {
    const detailsList = document.querySelectorAll('details')
    function expand() {
      detailsList.forEach((details) => {
        details.removeAttribute('open')
      })
    }
    detailsList.forEach((details) => {
      details.querySelector('summary').addEventListener('click', expand)
    })
    return () => {
      detailsList.forEach((details) => {
        details.querySelector('summary').removeEventListener('click', expand)
      })
    }
  }, [])
  return (
    <PokedexLinksStyled>
      <details>
        <summary>
          <h3>¿Quieres aprender HTML, CSS y JS?</h3>
        </summary>
        <Link href="/cursos/desarrollo-web" id="s-desarrollo-web">
          Crea tu primer proyecto con
          {' '}
          <u>este curso gratuito</u>
        </Link>
      </details>
      <details>
        <summary>
          <h3>¿Quieres entender como funciona React y construir tu propia versión?</h3>
        </summary>
        <Link href="/cursos/javascript-react" id="s-javascript-react">
          Toma el
          {' '}
          <u>Curso de JavaScript Avanzado</u>
        </Link>
      </details>
      <details>
        <summary>
          <h3>Construyamos una pokedex juntos</h3>
        </summary>
        <Link href="/cursos/pokedex" id="s-pokedex-course">
          Te explico el paso a paso en
          {' '}
          <u>este taller</u>
        </Link>
        <Link href="/aprender/pokedex/creando-el-componente-de-cover-y-animacion-3d" id="s-free-class">
          Toma
          {' '}
          <u>una clase gratuita</u>
          {' '}
          sobre elementos 3D
        </Link>
      </details>
      <details>
        <summary>
          <h3>¿Quieres crear tu portafolio?</h3>
        </summary>
        <Link href="/proyectos/pokedex" id="s-diseños-profesionales">
          Construye
          {' '}
          <u>diseños profesionales</u>
          {' '}
          , nosotros los revisamos, los aprobamos y creamos tu portafolio.
        </Link>
      </details>
    </PokedexLinksStyled>
  )
}

export default PokedexLinks
